
// SVG Icon: localfile
export default { id: "terriajs-localfile" };
export const id = "terriajs-localfile";
export const name = "localfile";
